import React from "react";
import { ArticleSummary } from "../types";
import ArticleCard from "../articleCard";

type RelatedArticlesProps = {
  articles: ArticleSummary[];
  showViewAll: boolean;
  onViewAll: () => void;
  showMore: boolean;
  onShowMore: () => void;
  loadingMore: boolean;
};

const RelatedArticles = ({
  articles,
  showViewAll,
  onViewAll,
  showMore,
  onShowMore,
  loadingMore,
}: RelatedArticlesProps) => {
  if (!articles.length) return null;

  return (
    <section className="related-articles">
      <div className="related-articles-header">
        <h2 className="related-articles-title">You might also like</h2>
        {showViewAll && (
          <button
            type="button"
            className="related-articles-action"
            onClick={onViewAll}
          >
            View all
          </button>
        )}
      </div>
      <div className="related-articles-grid">
        {articles.map((article) => (
          <ArticleCard key={article._id} article={article} />
        ))}
      </div>
      {showMore && (
        <div className="related-articles-more">
          <button
            type="button"
            className="related-articles-action"
            onClick={onShowMore}
            disabled={loadingMore}
          >
            {loadingMore ? "Loading..." : "Show more"}
          </button>
        </div>
      )}
    </section>
  );
};

export default RelatedArticles;
